import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import theme from "../../theme/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import GoalCardInDashboard from "../GoalCardInDashboard/GoalCardInDashboard";
import BlankGoalCard from "../GoalCardInDashboard/BlankGoalCard";
import { getUserGoal } from "../../redux/actions";
import ThankYouModal from "../ThankYouModal/ThankYouModal";
import AccountDetailsModal from "../AccountDetailsModal/AccountDetailsModal";
import LoadingBar from "../LoadingBar/LoadingBar";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .formContainer {
    max-width: 800px;
    width: 100%;
    margin-top: 3%;
  }

  .header {
    display: flex;
  }

  .leftColumn {
    flex: 1;
  }

  .rightColumn {
    flex: 1;
    text-align: right;
    display: flex;
    flex-direction: column-reverse;
  }

  .headerName {
    color: ${theme.colors.primaryStrong2X};
    border-bottom: 3px solid #6ac7dd;
    display: inline-block;
    font-size: 24px;
    font-weight: 700;
    padding-bottom: 5px;
  }

  .accountDetailsLinkButton {
    color: ${theme.colors.primaryStrong2X};
    cursor: pointer;
  }

  .body {
    margin-top: 20px;
  }

  .addGoalButton {
    width: 100%;
    background-color: ${theme.colors.primary};
    color: white;
    border-radius: 8px;
    text-align: left;
    border: none;
    padding: 22px 40px;
    font-size: 24px;
    position: relative;
    cursor: pointer;
  }

  .newGoalButtoName {
    position: absolute;
    top: 28px;
    left: 90px;
  }

  .allgoals {
    color: ${theme.colors.primaryStrong2X};
    font-weight: 700;
    margin-top: 25px;
  }

  .goalWrapper {
    margin-top: 15px;
  }
`;

const MyGoalBody = () => {
  let { from } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { userGoalDetails } = useSelector((state) => state.user);

  const [goalData, setGoalData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(isLoading);
  const [isThankYouModalVisible, setIsThankYouModalVisible] = useState(false);
  const [isAccountDetailsModalVisible, setIsAccountDetailsModalVisible] =
    useState(false);

  const handleAddnewGoal = () => {
    history.push("/goal-picker");
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(getUserGoal());
    if (from) {
      setIsThankYouModalVisible(true);
    }
  }, [dispatch, from]);

  useEffect(() => {
    if (userGoalDetails && !from) {
      setIsLoading(false);
      setGoalData(userGoalDetails);
    }
  }, [userGoalDetails, from]);

  const handleThankYouModalClose = () => {
    history.push("/strategy-screen");
    setIsThankYouModalVisible(false);
  };

  return (
    <BodyWrapper>
      {(isLoaded || isLoading) && (
        <LoadingBar isLoading={isLoading} setIsLoaded={setIsLoaded} />
      )}
      {isThankYouModalVisible && (
        <ThankYouModal onClose={handleThankYouModalClose} />
      )}
      {isAccountDetailsModalVisible && (
        <AccountDetailsModal onClose={setIsAccountDetailsModalVisible} />
      )}
      <div className="formContainer">
        <div className="header">
          <div className="leftColumn">
            <div className="headerName">My Goals</div>
          </div>
          <div className="rightColumn">
            <div
              className="accountDetailsLinkButton"
              onClick={() => {
                setIsAccountDetailsModalVisible(true);
              }}
            >
              Account Details
            </div>
          </div>
        </div>
        <div className="body">
          <button className="addGoalButton" onClick={handleAddnewGoal}>
            <FontAwesomeIcon icon={faPlusSquare} style={{ fontSize: "40px" }} />{" "}
            <span className="newGoalButtoName"> Add a New Goal</span>
          </button>
          <div className="allgoals">All Goals</div>
          <div className="goalWrapper">
            {goalData.length > 0 ? (
              goalData.map((data) => (
                <GoalCardInDashboard
                  id={data.id}
                  status={data.status}
                  goalName={data.goalType}
                />
              ))
            ) : (
              <div>
                <BlankGoalCard />
              </div>
            )}
          </div>
        </div>
      </div>
    </BodyWrapper>
  );
};

export default MyGoalBody;
